export default "__VITE_ASSET__6f0be9a3__"